import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ResponseObject } from '../models/response-object.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssociationPriceListDestinationService {

  private URL = environment.api + "api/erp/association-price-list-destination";

  constructor(
    private http: HttpClient
  ) { }

  getAssociateCompanies(destinationId: number): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(`${this.URL}/destination/${destinationId}`);
  }

  createRelationDestinationPriceList(destinationId: number, priceListId: number): Observable<ResponseObject> {
    const params = new HttpParams()
      .set('destinationId', destinationId)
      .set('priceListId', priceListId);

    return this.http.post<ResponseObject>(`${this.URL}/create`, null, { params });
  }

  deleteRelationDestinationPriceList(destinationId: number, priceListId: number): Observable<ResponseObject> {
    const params = new HttpParams()
      .set('destinationId', destinationId)
      .set('priceListId', priceListId);

    return this.http.delete<ResponseObject>(`${this.URL}/delete`, { params });
  }
}
